export default {
	back_to_intel_retail_edge_program: "Volver al Programa Intel® Retail Edge",
	other_names_and_brands_could_be_claimed_as_third_party_property: "Otros nombres y marcas podrían ser reclamados como propiedad de terceros.",
	trademarks: "Marcas Registradas"
}
